import { render } from "./AccountContactView.vue?vue&type=template&id=33f25596"
import script from "./AccountContactView.vue?vue&type=script&lang=js"
export * from "./AccountContactView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__